import SEO from "@/components/SEO";
import { BtnPrimary } from "@/components/Bits";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="mx-auto max-w-3xl px-6 py-40 text-left">
      <SEO title="Page not found" description="The page you are looking for does not exist." path="/404" />
      <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-brand">404</p>
      <h1 className="mt-6 font-serif text-5xl font-semibold tracking-tight md:text-6xl">This page took the day off.</h1>
      <p className="mt-5 max-w-md text-base text-mute">
        The link you followed doesn't exist — but verified local help is only a click away.
      </p>
      <div className="mt-9">
        <BtnPrimary to="/" testid="notfound-home-btn">Back to home</BtnPrimary>
      </div>
    </div>
  );
}
